module.exports = __webpack_public_path__ + "media/images/occupied_seats-2a538a8c66442416e3fc89bd267a6e13.svg";